import { buildCanonicalUrl } from "@/core/site"

export interface LocaleVersion {
  /** BCP 47 tag, e.g. "en-AU". */
  hreflang: string
  /** URL prefix without slashes, "" for the English root. */
  localePrefix: string
}

export type HreflangLink = { rel: "alternate"; hreflang: string; href: string }

/**
 * hreflang set for one page. `versions` must list only versions that really exist for this page
 * (Owner 2026-10-27: English only today, so callers pass at most one and get nothing back).
 * Every version emits the same set, so the set is reciprocal and self-referencing by
 * construction. `x-default` is the same page's English URL (the version with prefix "").
 */
export function buildHreflangLinks(
  path: string,
  versions: readonly LocaleVersion[],
): HreflangLink[] {
  if (versions.length < 2) return []
  const links: HreflangLink[] = versions.map((v) => ({
    rel: "alternate",
    hreflang: v.hreflang,
    href: buildCanonicalUrl(path, v.localePrefix),
  }))
  links.push({ rel: "alternate", hreflang: "x-default", href: buildCanonicalUrl(path) })
  return links
}
